import { createSelector } from 'reselect'

import selectJiraProjectsById from './selectJiraProjectsById'

export default createSelector(selectJiraProjectsById, Object.values)
